import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { getCustomerNvOrgListAsync, getAdminNvOrgListAsync, getChartListAsync, getChartItemAsync  } from './BusinessMonitoringChartsAsyncThunk';


const initialState = {
    isAdminMode: false,
    nvItemList: [],
    chartItemList: []
}; 

const businessMonitoringChartsSlice = createSlice({
  name: 'businessMonitoringChartsBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
      reducer: (state, action) => {
          state.isAdminMode = action.payload.isAdminMode;
      },
      prepare: (action) => {
          const currentBlock = action.currentBlock;

          let payload = {
            isAdminMode: !!currentBlock.isAdminMode?.value
          };
          return { payload: payload };
      }
    },    
    clearChartItemList: (state, action) => {
      state.chartItemList = [];
    },
    reportDWH: (state, action) => {},
  },
  extraReducers: {
    [getCustomerNvOrgListAsync.pending]: (state, action) => {
        state.nvItemList = [];
        state.chartItemList = [];
    },    
    [getCustomerNvOrgListAsync.fulfilled]: (state, action) => {
        if (!action.payload) { return; }
        state.nvItemList = action.payload.nvItemList;
    },
    [getAdminNvOrgListAsync.pending]: (state, action) => {
        state.nvItemList = [];
        state.chartItemList = [];
    },    
    [getAdminNvOrgListAsync.fulfilled]: (state, action) => {
        if (!action.payload) { return; }
        state.nvItemList = action.payload.nvItemList;
    },    
    [getChartListAsync.pending]: (state, action) => {
        state.chartItemList = [];
    }, 
    [getChartListAsync.fulfilled]: (state, action) => {
        if (!action.payload) { return; }
        state.chartItemList =  action.payload.chartItemList;
    },
    [getChartItemAsync.fulfilled]: (state, action) => {
        if (!action.payload) { return; }       
        const updatedItem = action.payload;     
        const index = state.chartItemList.findIndex(x => x.graphId === updatedItem.graphId);
        if (index != -1) {
            state.chartItemList[index] = updatedItem;
        }        
    },    
  },
})
export const {
  resetBlock,
  initBlock,
  clearChartItemList,
  reportDWH,
} = businessMonitoringChartsSlice.actions;


export default businessMonitoringChartsSlice.reducer;
